import React from 'react';
import { BookOpen, Droplets, HandHeart, Landmark, LayoutGrid, LucideProps, Scale, Store, Users } from 'lucide-react';
import { CategoryKey } from '../../types';
import { getCategory } from '../../config/categories';

/**
 * Icons named in src/config/categories.ts. Listed one by one (not the whole
 * lucide library) to keep the site small; a new category's icon is added here.
 */
const ICONS: Record<string, React.ComponentType<LucideProps>> = {
  Landmark,
  HandHeart,
  Droplets,
  Scale,
  Users,
  Store,
  BookOpen,
};

export default function CategoryIcon({ category, ...props }: { category: CategoryKey } & LucideProps) {
  const Icon = ICONS[getCategory(category).icon] ?? LayoutGrid;
  return <Icon aria-hidden {...props} />;
}
